// Format category slug to display name
export function formatCategoryLabel(category: string): string {
  // Handle special cases
  const specialCases: Record<string, string> = {
    'seo': 'SEO',
    'api': 'API',
    'ui': 'UI',
    'ux': 'UX',
    'ai': 'AI',
    'ml': 'ML',
    'css': 'CSS',
    'html': 'HTML',
    'js': 'JavaScript',
    'ts': 'TypeScript',
  };

  // Check if it's a special case
  const lowerCategory = category.toLowerCase();
  if (specialCases[lowerCategory]) {
    return specialCases[lowerCategory];
  }

  // Otherwise, capitalize each word and replace hyphens with spaces
  return category
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}

// Format date for display
export function formatBlogDate(date: Date | string): string {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  
  return dateObj.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}

// Format reading time
export function formatReadingTime(minutes: number): string {
  return `${minutes} min read`;
}